import i18n from '@/i18n'
import { content } from './content'

export const getContent = () => {
  const code = i18n.language

  return content
}
